exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_cf3809f{display:inline-block}.tr_4a1337f{height:39px;line-height:39px;border-bottom:1px solid #eaecf0}.box_cf3809f p:last-of-type{border-bottom:0 solid #eaecf0}.flex_5e36c65{display:flex;width:320px;justify-content:space-between;align-items:center}.inputNumberW_648aec6{width:80px!important}.inputW_fa079b7{width:400px!important}.select_105b5d7{width:120px!important}.tableW_59b5787{width:600px;padding-left:60px;margin:10px 0 20px}.textarea_ec0a01c{width:400px!important;height:200px;margin-bottom:30px}.textarea_ec0a01c .k-textarea{height:200px!important;resize:none}.desc_7f46889{color:#999}.goods_table_e7f8f02 .k-tablebox{overflow:visible!important}.query_item_274355a{height:60px;line-height:60px;border-bottom:1px solid #e3e3e3;margin-bottom:0!important}.td_item_b4cee79{height:35px;line-height:35px;border-bottom:1px solid #eaecf0}.td_item_b4cee79:last-child{border:none}", ""]);

// exports
exports.locals = {
	"box": "box_cf3809f",
	"tr": "tr_4a1337f",
	"flex": "flex_5e36c65",
	"inputNumberW": "inputNumberW_648aec6",
	"inputW": "inputW_fa079b7",
	"select": "select_105b5d7",
	"tableW": "tableW_59b5787",
	"textarea": "textarea_ec0a01c",
	"desc": "desc_7f46889",
	"goods_table": "goods_table_e7f8f02",
	"query_item": "query_item_274355a",
	"td_item": "td_item_b4cee79"
};